import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router';
import { BootstrapVue } from 'bootstrap-vue';

const Page = () => import('@/components/Page.vue');

import FormRegister from './components/FormRegister.vue';
import PageResult from './components/PageResult.vue';

// Styles
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false

Vue.use(Router);
Vue.use(BootstrapVue);


const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/:language',
      redirect: 'form',
      component: Page,
      children: [
        {
          path: '',
          name: 'form',
          component: FormRegister,
        },
        {
          path: '/:language/resultado',
          name: 'result',
          component: PageResult,
        },
      ]
    },
    {
      path: '*',
      redirect: '/pt',
    },
  ],
});


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')